module.exports = __webpack_public_path__ + "static/wand_of_polymorph-dbb632c018a00c48cdfd5f154285652a.jpeg";